(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/swedbankpay-checkout/assets/javascripts/swedbankpay-checkout.js') >= 0) return;  svs.modules.push('/components/accountservices/swedbankpay-checkout/assets/javascripts/swedbankpay-checkout.js');
"use strict";


svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout = class SwedbankPayCheckout {
  constructor(options) {
    var _svs;
    const isRc = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.swedbankpay_checkout) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.isRc) || false;
    this.logger = new svs.core.log.Logger('accountservices:swedbankpay-checkout');
    this.pollingTransactionData = [];
    this.swpClientId = '';
    this.swedbankPayScript = undefined;
    this.options = options;
    this.errorHbsNotExist = {
      error: {
        code: 1,
        message: 'Component accountservices/swedbankpay-checkout does not appear to exist in hbs'
      }
    };
    this.SWP_CALLBACK_EVENTS = {
      onPaymentCompleted: 'PaymentCompleted',
      onError: 'Error',
      onPaymentFailed: 'PaymentFailed',
      onPaymentCanceled: 'PaymentCanceled',
      onPaymentTransactionFailed: 'PaymentTransactionFailed'
    };
    this.applePayVersion = isRc ? '99' : '1';
    this.SWP_API = {
      INIT: {
        applepay: "/player/".concat(this.applePayVersion, "/deposit"),
        creditcard: '/player/1/deposit',
        subscription: '/player/1/payment/subscription'
      },
      POLL: {
        applepay: "/player/".concat(this.applePayVersion, "/deposit"),
        creditcard: '/player/1/deposit'
      },
      DELETE: {
        applepay: "/player/".concat(this.applePayVersion, "/deposit"),
        creditcard: '/player/1/deposit'
      }
    };

    const serverSideModel = svs.accountservices && svs.accountservices.swedbankpay_checkout && svs.accountservices.swedbankpay_checkout.data && svs.accountservices.swedbankpay_checkout.data.swpData || undefined;
    const serverSideGeneratedClientId = svs.accountservices && svs.accountservices.swedbankpay_checkout && svs.accountservices.swedbankpay_checkout.data && svs.accountservices.swedbankpay_checkout.data.swpClientId || undefined;

    const securitypolicyviolationCallback = e => {
      this.logger.info('Event securitypolicyviolation triggered!');
      this.logger.info("blockedURI: ".concat(e.blockedURI));
      this.logger.info("violatedDirective: ".concat(e.violatedDirective));
      this.logger.info("originalPolicy: ".concat(e.originalPolicy));
    };
    document.removeEventListener('securitypolicyviolation', securitypolicyviolationCallback);
    document.addEventListener('securitypolicyviolation', securitypolicyviolationCallback);
    if (serverSideModel) {
      if (serverSideModel.dataError) {
        this.logger.info("Error when initializing Swedbank Pay server side. Error code: ".concat(serverSideModel.errorCode ? serverSideModel.errorCode : 0));
        this.options && this.options.errorFn && this.options.errorFn(serverSideModel, {});
      } else {
        svs.events.publish('/loader/show');
        this.logger.debug('Got swpData for Swedbank Pay creditcard transaction');
        this.options.swpData = serverSideModel;
        this.logger.debug("Got swpData from server side model: ".concat(JSON.stringify(this.options.swpData)));
        const _self = this;
        this.checkIfReady(() => {
          this.swpClientId = serverSideGeneratedClientId;
          this.updateQuerystringWithParamAndValue('swpid', this.swpClientId);
          svs.core.userSession.set("swpData".concat(this.swpClientId), this.options.swpData, (err, response) => {
            if (!err) {
              _self.prepareForSwedbankPayTransaction(response.paymentType);
              _self.swpCallback(response);
            }
          });
        });
      }
    } else {
      svs.utils.url.refreshQueryString();
      const {
        swpid
      } = svs.utils.url.queryString;
      if (swpid) {
        this.swpClientId = swpid;
        svs.core.userSession.get("swpData".concat(swpid), (err, result) => {
          if (!err && result) {
            svs.events.publish('/loader/show');
            this.logger.debug('Got swpData for Swedbank Pay creditcard transaction');
            this.options.swpData = result;
            this.logger.debug("Coming back from Swedbank Pay: ".concat(JSON.stringify(this.options.swpData)));
            const _self = this;
            this.checkIfReady(() => {
              _self.swpCallback(_self.options.swpData, true);
            });
          } else {
            this.clearUrlParam('swpid');
          }
        });
      }
    }
  }

  async getAcceptedWallets() {
    const swedbankPayScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('async', '');
      script.setAttribute('id', 'swpEligibilityScript');
      script.setAttribute('src', 'https://ecom.payex.com/checkout/core/integration');
      script.onload = async () => {
        this.logger.debug('swedbankPayScript Loaded!');
        resolve();
      };
      script.onerror = async () => {
        this.logger.warn('Failed to load Swedbank Pay Eligibility Script');
        reject();
      };
      try {
        document.head.appendChild(script);
      } catch (_unused) {}
    });
    const pxXpayScript = new Promise((resolve, reject) => {
      let intervalId;
      const pxXpayScriptSelector = '#px-xpay-script';
      let script = document.querySelector(pxXpayScriptSelector);
      if (!script) {
        const observer = new MutationObserver(() => {
          if (document.querySelector(pxXpayScriptSelector)) {
            observer.disconnect();
            script = document.querySelector(pxXpayScriptSelector);
            script.onload = () => {
              this.logger.debug('pxXpayScript Loaded!');
              clearTimeout(intervalId);
              resolve();
            };
            script.onerror = async () => {
              this.logger.warn('Failed to load Swedbank Pay px-xpay-script');
              reject();
            };
          }
        });
        observer.observe(document.head, {
          childList: true,
          subtree: false,
          attributes: false
        });
        intervalId = setTimeout(() => {
          observer.disconnect();
          this.logger.info('Swedbank Pay px-xpay-script not loaded after 3 seconds');
          reject();
        }, 3000);
      } else {
        resolve();
      }
    });
    let acceptedWallets = [];
    try {
      await Promise.all([swedbankPayScript, pxXpayScript]);
      if (window && window.payex) {
        acceptedWallets = await window.payex.getAcceptedWallets();
      } else {
        this.logger.info('Swedbank Pay Eligibility script failed. window.payex object not available');
      }
      this.logger.debug("Accepted wallets from Swedbank Pay: ".concat(acceptedWallets));
      return acceptedWallets;
    } catch (_unused2) {
      this.logger.warn('Failed to check Accepted Wallets from Swedbank Pay');
      return acceptedWallets;
    }
  }

  checkIfReady(callback) {
    $('.swedbankpay-checkout-wrapper').ready(() => {
      this.logger.debug("dom el: ".concat($('.swedbankpay-checkout-wrapper').length > 0));
      this.logger.debug("this el: ".concat(Boolean(this.el)));
      if (this.el && $('.swedbankpay-checkout-wrapper').length > 0) {
        callback && callback();
      } else {
        this.render();
        setTimeout(() => this.checkIfReady(callback), 800);
      }
    });
  }

  handleBackButton() {
    if (this.options.backButton) {
      if (typeof this.options.backButtonText === 'string' && this.options.backButtonText.length > 0) {
        $('.swedbankpay-checkout-button-wrapper .js-swedbankpay-checkout-backbutton').text(this.options.backButtonText);
      }
      $('.swedbankpay-checkout-button-wrapper .js-swedbankpay-checkout-backbutton').show();
    } else {
      $('.swedbankpay-checkout-button-wrapper .js-swedbankpay-checkout-backbutton').hide();
    }
  }

  render() {
    if (this.options && this.options.el) {
      if (this.options.el instanceof Element) {
        this.el = this.options.el;
      } else {
        this.el = $(".".concat(this.options.el))[0];
      }
      this.options.el = this.el;
      const viewModel = {
        backButton: this.options.backButton ? this.options.backButton : false,
        backButtonText: this.options.backButtonText ? this.options.backButtonText : 'Tillbaka',
        prefixText: this.options.prefixText ? this.options.prefixText : 'Insättningar',
        isNotInfoText: this.options.isNotInfoText ? this.options.isNotInfoText : false
      };
      this.el.innerHTML = svs.accountservices.swedbankpay_checkout.partials.swedbankpay_checkout(viewModel);
      this.logger.debug("Rendered Swedbank Pay Checkout in element");
    } else {
      try {
        this.el = $(".swedbankpay-checkout-wrapper")[0];
        if (this.el) {
          this.options.el = this.el;
          if (typeof this.options.backButton !== 'undefined') {
            this.handleBackButton();
          }
          if (this.options.prefixText && this.options.prefixText.length > 0) {
            $('.swedbankpay-checkout-prefix-text').text(this.options.prefixText);
          }
          if (this.options.isNotInfoText === true) {
            $('.swedbankpay-checkout-info-wrapper')[0].style.display = 'none';
          }
        } else {
          svs.events.publish('/loader/hide');
          this.logger.warn("Error in function render() - ".concat(this.errorHbsNotExist.error.message));
        }
      } catch (err) {
        svs.events.publish('/loader/hide');
        this.logger.warn("Error in function render() - catch - ".concat(this.errorHbsNotExist.error.message), err);
      }
    }
  }

  deposit(transAmount, paymentType) {
    const data = {
      transAmount,
      paymentType
    };
    this.logger.info("Start deposit. Amount: ".concat(transAmount, ". PaymentType: ").concat(paymentType));
    this.checkIfReady(() => {
      this.execute(data);
    });
  }

  updateCard() {
    const data = {
      transAmount: '0,00',
      paymentType: 'creditcard'
    };
    this.logger.info("Start update card");
    this.checkIfReady(() => {
      this.execute(data);
    });
  }

  startSubscription(subscrId, transAmount) {
    let returnUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    const data = {
      subscrId,
      transAmount,
      returnUrl,
      paymentType: 'creditcard'
    };
    this.logger.info("Start subscription. Amount: ".concat(transAmount, ". SubID: ").concat(subscrId, ". ReturnUrl: ").concat(returnUrl));
    this.checkIfReady(() => {
      this.execute(data, true);
    });
  }

  execute(data) {
    var _data$paymentType, _data$paymentType2;
    let startSubscription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!this.el && $('.swedbankpay-checkout-wrapper').length === 0) {
      svs.events.publish('/loader/hide');
      this.logger.error("Error in function execute() - ".concat(this.errorHbsNotExist.error.message));
      this.options && this.options.errorFn && this.options.errorFn(this.errorHbsNotExist, data);
      return false;
    }
    this.swpClientId = Math.floor(Math.random() * 1000000000);
    const retUrl = this.getReturnUrlWithSwpClientId(data.returnUrl);
    data.paymentUrl = retUrl;
    data.completeUrl = retUrl;
    data.disablePaymentMenu = true;
    data.cardType = (data === null || data === void 0 || (_data$paymentType = data.paymentType) === null || _data$paymentType === void 0 ? void 0 : _data$paymentType.toLowerCase()) === 'applepay' ? 2 : 1;
    const options = {
      method: 'POST',
      path: startSubscription ? this.SWP_API.INIT.subscription : this.SWP_API.INIT[data === null || data === void 0 || (_data$paymentType2 = data.paymentType) === null || _data$paymentType2 === void 0 ? void 0 : _data$paymentType2.toLowerCase()],
      data
    };
    this.logger.info("Execute. PaymentUrl (ReturnUrl for Swedbank Pay): ".concat(data.paymentUrl));
    const _self = this;
    svs.core.jupiter.call(options, response => {
      this.logger.info("Success initializing Swedbank Pay");
      _self.handleInitialResponse(response, data.transAmount, data.paymentUrl, data.paymentType);
    }, err => {
      this.logger.info("Error initializing Swedbank Pay", err);
      this.options && this.options.errorFn && this.options.errorFn(err, data);
    });
  }

  handleInitialResponse(response, amount, returnUrl, currentPaymentType) {
    const _self = this;
    try {
      this.logger.debug("paymentOrderToken: ".concat(response.paymentOrderToken));
      this.logger.debug("paymentUrl: ".concat(response.href));
      this.logger.debug("SWP Id - Last 6: ".concat(response.href.substr(-20).replace('&culture=sv-SE', '')));
    } catch (e) {
      this.logger.debug("initialPaymentResponse: ".concat(JSON.stringify(response)));
    }
    this.logger.info("Handle initial response");
    const currentPaymentTypeLower = currentPaymentType === null || currentPaymentType === void 0 ? void 0 : currentPaymentType.toLowerCase();
    this.prepareForSwedbankPayTransaction(currentPaymentTypeLower);
    response.returnUrl = returnUrl;
    response.amount = amount;
    response.paymentType = currentPaymentTypeLower;

    const {
      paymentType,
      paymentOrderToken,
      href
    } = response;
    const swpResponse = {
      amount,
      paymentType,
      paymentOrderToken,
      href,
      returnUrl
    };

    svs.core.userSession.set("swpData".concat(this.swpClientId), swpResponse, (err, response) => {
      if (!err) {
        _self.logger.info("Saved Swedbank Pay data to userSession (swpData".concat(this.swpClientId, "). Data: ").concat(JSON.stringify(response)));
        _self.swpCallback(response);
      }
    });
  }

  runCleanUpAndErrorFn(context) {
    var _context$options;
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    svs.events.publish('/loader/hide');
    context.cleanUpSwedbankPayTransaction();
    context === null || context === void 0 || (_context$options = context.options) === null || _context$options === void 0 || _context$options.errorFn(error, data);
  }

  swpCallback(response) {
    let comingBack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (comingBack) {
      this.logger.info("Coming back from Swedbank Pay");
      let retUrl = response.returnUrl.split('?')[0];
      let currUrl = location.href.split('?')[0];
      retUrl = retUrl.replace(/^http(s?):\/\//i, '');
      currUrl = currUrl.replace(/^http(s?):\/\//i, '');
      retUrl = retUrl.replace(/\/\//g, '/');

      if (retUrl !== currUrl) {
        svs.events.publish('/loader/hide');
        this.logger.warn("Seems like coming back from Swedbank Pay, but current location.href is not the same as returnUrl");
        this.logger.info("Current url no qs: ".concat(location.href.split('?')[0], ". Calculated currUrl: ").concat(currUrl));
        this.logger.info("Return url no qs: ".concat(response.returnUrl.split('?')[0], ". Calculated returnUrl: ").concat(retUrl));
        this.cleanUpSwedbankPayTransaction();
        return false;
      }
    }
    const _self = this;
    this.paymentComplete = false;
    this.paymentError = false;

    if ($('#swpScript').length === 0) {
      $('#swpScript').remove();

      this.swedbankPayScript && this.swedbankPayScript.parentNode && typeof this.swedbankPayScript.parentNode.removeChild === 'function' && this.swedbankPayScript.parentNode.removeChild(this.swedbankPayScript);
      this.swedbankPayScript = null;

      this.swedbankPayScript = document.createElement('script');
      this.swedbankPayScript.setAttribute('id', 'swpScript');
      this.swedbankPayScript.setAttribute('src', response.href);
      const loadPaymentMenu = () => {
        var _payex;
        (_payex = payex) === null || _payex === void 0 || _payex.hostedView.paymentMenu({
          container: 'payment-menu',
          culture: 'sv-SE',
          onError: param => {
            _self.gaTrackingSwedbankPay(response.paymentType, _self.SWP_CALLBACK_EVENTS.onError, param);
            _self.logger.debug("SWP - onError: ".concat(JSON.stringify(param)));
            if (comingBack) {
              _self.paymentError = true;
              _self.prepareForSwedbankPayTransaction(response.paymentType);
              svs.events.publish('/loader/hide');
            }
          },
          onPaymentFailed: param => {
            _self.gaTrackingSwedbankPay(response.paymentType, _self.SWP_CALLBACK_EVENTS.onPaymentFailed, param);
            _self.logger.debug("SWP - onPaymentFailed: ".concat(JSON.stringify(param)));
            if (comingBack) {
              _self.paymentError = true;
              _self.prepareForSwedbankPayTransaction(response.paymentType);
              svs.events.publish('/loader/hide');
            }
          },
          onPaymentCanceled: param => {
            _self.gaTrackingSwedbankPay(response.paymentType, _self.SWP_CALLBACK_EVENTS.onPaymentCanceled, param);
            _self.logger.debug("SWP - onPaymentCanceled: ".concat(JSON.stringify(param)));
            if (comingBack) {
              _self.paymentError = true;
              _self.prepareForSwedbankPayTransaction(response.paymentType);
              svs.events.publish('/loader/hide');
            }
          },
          onPaymentTransactionFailed: param => {
            _self.gaTrackingSwedbankPay(response.paymentType, _self.SWP_CALLBACK_EVENTS.onPaymentTransactionFailed, param);
            _self.logger.debug("SWP - onPaymentTransactionFailed: ".concat(JSON.stringify(param)));
            if (comingBack) {
              _self.paymentError = true;
              _self.prepareForSwedbankPayTransaction(response.paymentType);
              svs.events.publish('/loader/hide');
            }
          },
          onPaymentCompleted: param => {
            _self.gaTrackingSwedbankPay(response.paymentType, _self.SWP_CALLBACK_EVENTS.onPaymentCompleted, param);
            _self.logger.debug("SWP - onPaymentCompleted: ".concat(JSON.stringify(param)));
            _self.paymentComplete = true;
            svs.events.publish('/loader/hide');
          }
        }).open();
      };
      try {
        this.swedbankPayScript.onerror = e => {
          var _e$currentTarget;
          const srcValue = (e === null || e === void 0 || (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget = _e$currentTarget.attributes) === null || _e$currentTarget === void 0 || (_e$currentTarget = _e$currentTarget.src) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.value) || '';
          _self.logger.info("Error in loading SWP Script (onerror): ".concat(srcValue));
          _self.runCleanUpAndErrorFn(_self, response, {
            code: 500001
          });
        };
        this.swedbankPayScript.onload = () => {
          try {
            _self.logger.info("SWP - onload");
            let i = 1;
            const tryLoadPayment = () => {
              setTimeout(() => {
                if (typeof payex !== 'undefined' && payex.hostedView && typeof payex.hostedView.paymentMenu === 'function') {
                  _self.logger.info("Payex variable was a function on try ".concat(i));
                  loadPaymentMenu();
                } else if (i > 9) {
                  _self.logger.info("Payex variable was not found");
                  _self.runCleanUpAndErrorFn(_self, response, {
                    code: 500001
                  });
                } else {
                  i++;
                  tryLoadPayment();
                }
              }, 500);
            };

            tryLoadPayment();
          } catch (e) {
            _self.logger.info("Error in loading SWP Script (open): ".concat(e));
            _self.runCleanUpAndErrorFn(_self, response, {
              code: 500001
            });
          }
        };
      } catch (e) {
        _self.logger.info("Error in loading SWP Script (onload): ".concat(e));
        _self.runCleanUpAndErrorFn(_self, response, {
          code: 500001
        });
      }
      try {
        const head = document.getElementsByTagName('head')[0];
        head.appendChild(this.swedbankPayScript);
      } catch (e) {
        _self.logger.info("Error in appending SWP Script: ".concat(e));
      }

      setTimeout(() => {
        const paymentMenuHasContent = $('#payment-menu').length > 0 && $('#payment-menu')[0].innerHTML !== '';
        if (paymentMenuHasContent && !_self.paymentComplete && !_self.paymentError && comingBack) {
          _self.logger.info('payment-menu has content and no onPaymentCompleted call or no onError calls in 3 seconds, probably page reload');
          _self.prepareForSwedbankPayTransaction(response.paymentType);
          svs.events.publish('/loader/hide');
        }
      }, 3000);
      _self.startPollSwedbankPayTransaction(response);
    }
  }

  startPollSwedbankPayTransaction(data) {
    this.logger.info("Start polling. paymentOrderToken: ".concat(data.paymentOrderToken));
    const intervalId = setInterval(this.checkSwedbankPayTransaction, 2000, this, data, resp => {
      svs.events.publish('/deposit/complete');
      this.logger.info("Polling success. paymentOrderStatus: ".concat(resp && resp.paymentOrderStatus || 'unknown'));

      resp.amount = data.amount;
      resp.paymentType = data.paymentType;
      this.options && this.options.successFn && this.options.successFn(resp);
    }, error => {
      svs.events.publish('/loader/hide');
      this.logger.info("Polling error. paymentOrderStatus: ".concat(error && error.paymentOrderStatus || 'unknown'));
      this.cleanUpSwedbankPayTransaction();
      this.options && this.options.errorFn && this.options.errorFn(error, data);
    });
    this.pollingTransactionData.push({
      intervalId,
      paymentOrderToken: data.paymentOrderToken,
      paymentType: data.paymentType
    });
    this.logger.debug("intervalId: ".concat(intervalId));
  }

  checkSwedbankPayTransaction(context, data, successFn, errorFn) {
    var _data$paymentType3;
    if (document.visibilityState === 'hidden') {
      context.logger.debug('### hidden not polling');
      return;
    }
    context.logger.debug('### visible and polling');

    const options = {
      method: 'GET',
      path: "".concat(context.SWP_API.POLL[data === null || data === void 0 || (_data$paymentType3 = data.paymentType) === null || _data$paymentType3 === void 0 ? void 0 : _data$paymentType3.toLowerCase()], "/?paymentOrderToken=").concat(data.paymentOrderToken)
    };
    svs.core.jupiter.call(options, response => {
      svs.events.publish('/loader/hide');
      if (response && response.paymentOrderStatus && response.paymentOrderStatus == 5) {
        context.cleanUpSwedbankPayTransaction(false);
        successFn(response);
      } else if (response && response.paymentOrderStatus && (response.paymentOrderStatus == 3 || response.paymentOrderStatus == 4)) {
        context.cleanUpSwedbankPayTransaction();
        errorFn(response);
      }
    }, err => {
      var _err$responseJSON;
      context.logger.warn("Error calling polling api", err);
      if (((_err$responseJSON = err.responseJSON) === null || _err$responseJSON === void 0 || (_err$responseJSON = _err$responseJSON.error) === null || _err$responseJSON === void 0 ? void 0 : _err$responseJSON.code) !== 666) {
        context.logger.warn("Error calling polling api, not 666 error");
        svs.events.publish('/loader/hide');
        context.cleanUpSwedbankPayTransaction();
        context.options && context.options.errorFn && context.options.errorFn(err, data);
      }
    });
  }

  prepareForSwedbankPayTransaction(currentPaymentType) {
    this.logger.info('Preparing for Swedbank Pay transaction');
    if (currentPaymentType === 'applepay') {
      $('.swedbankpay-checkout-info').text('Insättningen med Apple Pay hanteras på ett säkert sätt av Swedbank Pay.');
    } else {
      $('.swedbankpay-checkout-info').text("".concat(this.options.prefixText ? this.options.prefixText : 'Insättning') + " kan g\xF6ras med alla bankkort utgivna i Sverige och betalningen hanteras p\xE5 ett s\xE4kert s\xE4tt av Swedbank Pay.");
    }
    $('.swedbankpay-checkout-info-wrapper').removeClass('hide');
    $('.swedbankpay-checkout').removeClass('hide');
    $('.swedbankpay-checkout-button-wrapper').removeClass('hide');

    $('.js-swedbankpay-checkout-backbutton').one('click', () => {
      this.logger.info("BackButton clicked");
      this.cleanUpSwedbankPayTransaction();
      this.options && this.options.backButtonCallback && typeof this.options.backButtonCallback === 'function' && this.options.backButtonCallback();
    });

    this.options && typeof this.options.prepareFn === 'function' && this.options.prepareFn(this.options.context || this);
  }

  cleanUpSwedbankPayTransaction() {
    let abortSwedbankPayTransaction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let keepInSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let runCleanUpFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    this.logger.info('Cleaning up Swedbank Pay transaction');
    for (const pollingData of this.pollingTransactionData) {
      clearInterval(pollingData.intervalId);
      this.logger.debug("Clearing intervalId: ".concat(pollingData.intervalId));
      if (abortSwedbankPayTransaction) {
        this.abortSwedbankPayTransaction(pollingData.paymentOrderToken, pollingData.paymentType);
      }
    }
    this.pollingTransactionData = [];

    this.clearUrlParam('swpid');
    if (!keepInSession) {
      const _self = this;
      svs.core.userSession.remove("swpData".concat(this.swpClientId), () => {
        svs.core.session.data.userSession.data["swpData".concat(this.swpClientId)] = undefined;
        _self.logger.debug("Removed Swedbank Pay data from userSession (swpData".concat(this.swpClientId, ")."));
      });
    }
    if (typeof payex !== 'undefined' &&
    payex.hostedView &&
    typeof payex.hostedView.paymentMenu === 'function' &&
    typeof payex.hostedView.paymentMenu().close === 'function') {
      payex.hostedView.paymentMenu().close();
    }

    $('.swedbankpay-checkout-info-wrapper').addClass('hide');
    $('.swedbankpay-checkout').addClass('hide');
    $('.swedbankpay-checkout-button-wrapper').addClass('hide');

    if (runCleanUpFunction) {
      this.options && this.options.cleanUpFn && typeof this.options.cleanUpFn === 'function' && this.options.cleanUpFn(this.options.context || this);
    }

    $('#swpScript').remove();
  }

  abortSwedbankPayTransaction(paymentOrderToken, paymentType) {
    if (!paymentOrderToken) {
      this.logger.info("No paymentOrderToken to abort");
      return;
    }
    const options = {
      method: 'DELETE',
      path: "".concat(this.SWP_API.DELETE[paymentType === null || paymentType === void 0 ? void 0 : paymentType.toLowerCase()], "/?paymentOrderToken=").concat(paymentOrderToken)
    };
    svs.core.jupiter.call(options, () => {
      this.logger.info("Aborted Swedbank Pay transaction with paymentOrderToken: ".concat(paymentOrderToken, " and paymentType: ").concat(paymentType));
    }, err => {
      this.logger.info('Error aborting Swedbank Pay transaction.', err);
    });
  }

  getReturnUrlWithSwpClientId(returnUrl) {
    const swpClientIdParam = 'swpid';
    const retUrl = returnUrl && returnUrl.length > 0 ? returnUrl : window.location.href;
    const swpClientIdDelim = retUrl.indexOf('?') > -1 ? '&' : '?';

    this.updateQuerystringWithParamAndValue(swpClientIdParam, this.swpClientId);
    return "".concat(retUrl + swpClientIdDelim + swpClientIdParam, "=").concat(this.swpClientId);
  }

  updateQuerystringWithParamAndValue(param, value) {
    this.clearUrlParam(param);
    svs.utils.url.refreshQueryString();
    let targetPath = svs.utils.url.currentPathEncodedParams();
    targetPath = svs.utils.url.updateQueryStringParameter(targetPath, param, value);
    window.history.replaceState({}, '', targetPath);
  }

  clearUrlParam(paramToClear) {
    svs.utils.url.refreshQueryString();
    const {
      [paramToClear]: currentParamToClear
    } = svs.utils.url.queryString;
    if (currentParamToClear) {
      let targetString = '';
      let delim = '?';
      for (const param in svs.utils.url.queryString) {
        if (param !== paramToClear) {
          targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
          delim = '&';
        }
      }
      window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
      svs.utils.url.refreshQueryString();
    }
  }

  gaTrackingSwedbankPay(paymentType, swpEvent, swpParams) {
    var _paymentType, _paymentType2;
    const swpDetails = swpParams && swpParams.details || (swpEvent === this.SWP_CALLBACK_EVENTS.onPaymentCompleted ? 'Completed' : 'Unknown Swedbank Pay callback details');
    const swpId = swpParams && swpParams.id || 'Unknown Swedbank Pay callback transaction id';
    this.logger.info("swpEvent: ".concat(swpEvent));
    this.logger.info("swpId: ".concat(swpId));
    this.logger.info("swpDetails: ".concat(swpDetails));

    if (((_paymentType = paymentType) === null || _paymentType === void 0 ? void 0 : _paymentType.toLowerCase()) === 'creditcard') {
      paymentType = 'CC';
    } else if (((_paymentType2 = paymentType) === null || _paymentType2 === void 0 ? void 0 : _paymentType2.toLowerCase()) === 'applepay') {
      paymentType = 'CC ApplePay';
    } else {
      paymentType = 'Unknown Payment Type';
    }
    svs.components.analytics.trackEvent({
      category: 'Deposits',
      action: "Deposit SWP Callback - ".concat(paymentType, " - ").concat(swpEvent),
      opt_label: swpDetails
    });
  }
};

 })(window);